import {
    GET_METER_READINGS,
    GET_METER_READINGS_SUCCESS,
    GET_METER_READINGS_FAILURE,
    GET_METER_READING_DETAILS,
    GET_METER_READING_DETAILS_SUCCESS,
    GET_METER_READING_DETAILS_FAILURE,
    GET_LAST_METER_READING,
    GET_LAST_METER_READING_SUCCESS,
    GET_LAST_METER_READING_FAILURE,
    CREATE_METER_READING,
    CREATE_METER_READING_SUCCESS,
    CREATE_METER_READING_FAILURE,
    CREATE_BULK_METER_READINGS,
    CREATE_BULK_METER_READINGS_SUCCESS,
    CREATE_BULK_METER_READINGS_FAILURE,
    UPLOAD_METER_READINGS,
    UPLOAD_METER_READINGS_SUCCESS,
    UPLOAD_METER_READINGS_FAILURE,
    DOWNLOAD_METER_READING_TEMPLATE,
    DOWNLOAD_METER_READING_TEMPLATE_SUCCESS,
    DOWNLOAD_METER_READING_TEMPLATE_FAILURE,
    UPDATE_METER_READING,
    UPDATE_METER_READING_SUCCESS,
    UPDATE_METER_READING_FAILURE,
    DELETE_METER_READING,
    DELETE_METER_READING_SUCCESS,
    DELETE_METER_READING_FAILURE,
    CLEAR_METER_READING_STATE
} from '../../../actions/index.types';

const initialState = {
    // List
    meterReadingsData: [],
    meterReadingsPagination: null,
    loading: false,
    error: null,

    // Details
    meterReadingDetails: null,
    detailsLoading: false,
    detailsError: null,

    // Last Reading
    lastReading: null,
    lastReadingLoading: false,
    lastReadingError: null,

    // Create
    createLoading: false,
    createError: null,
    createSuccess: false,

    // Bulk Create
    bulkCreateLoading: false,
    bulkCreateError: null,
    bulkCreateSuccess: false,
    bulkCreateResult: null,

    // Upload
    uploadLoading: false,
    uploadError: null,
    uploadSuccess: false,
    uploadResult: null,

    // Download Template
    downloadLoading: false,
    downloadError: null,

    // Update
    updateLoading: false,
    updateError: null,
    updateSuccess: false,

    // Delete
    deleteLoading: false,
    deleteError: null,
    deleteSuccess: false
};

const MeterReadingReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get All Meter Readings
        case GET_METER_READINGS:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_METER_READINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                meterReadingsData: action.data?.data || [],
                meterReadingsPagination: action.data?.meta?.pagination || null,
                error: null
            };
        case GET_METER_READINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.data
            };

        // Get Meter Reading Details
        case GET_METER_READING_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                detailsError: null
            };
        case GET_METER_READING_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                meterReadingDetails: action.data,
                detailsError: null
            };
        case GET_METER_READING_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                detailsError: action.data
            };

        // Get Last Meter Reading
        case GET_LAST_METER_READING:
            return {
                ...state,
                lastReadingLoading: true,
                lastReadingError: null
            };
        case GET_LAST_METER_READING_SUCCESS:
            return {
                ...state,
                lastReadingLoading: false,
                lastReading: action.data,
                lastReadingError: null
            };
        case GET_LAST_METER_READING_FAILURE:
            return {
                ...state,
                lastReadingLoading: false,
                lastReadingError: action.data
            };

        // Create Meter Reading
        case CREATE_METER_READING:
            return {
                ...state,
                createLoading: true,
                createError: null,
                createSuccess: false
            };
        case CREATE_METER_READING_SUCCESS:
            return {
                ...state,
                createLoading: false,
                createSuccess: true,
                createError: null
            };
        case CREATE_METER_READING_FAILURE:
            return {
                ...state,
                createLoading: false,
                createError: action.data,
                createSuccess: false
            };

        // Bulk Create Meter Readings
        case CREATE_BULK_METER_READINGS:
            return {
                ...state,
                bulkCreateLoading: true,
                bulkCreateError: null,
                bulkCreateSuccess: false,
                bulkCreateResult: null
            };
        case CREATE_BULK_METER_READINGS_SUCCESS:
            return {
                ...state,
                bulkCreateLoading: false,
                bulkCreateSuccess: true,
                bulkCreateResult: action.data,
                bulkCreateError: null
            };
        case CREATE_BULK_METER_READINGS_FAILURE:
            return {
                ...state,
                bulkCreateLoading: false,
                bulkCreateError: action.data,
                bulkCreateSuccess: false
            };

        // Upload Meter Readings
        case UPLOAD_METER_READINGS:
            return {
                ...state,
                uploadLoading: true,
                uploadError: null,
                uploadSuccess: false,
                uploadResult: null
            };
        case UPLOAD_METER_READINGS_SUCCESS:
            return {
                ...state,
                uploadLoading: false,
                uploadSuccess: true,
                uploadResult: action.data,
                uploadError: null
            };
        case UPLOAD_METER_READINGS_FAILURE:
            return {
                ...state,
                uploadLoading: false,
                uploadError: action.data,
                uploadSuccess: false
            };

        // Download Meter Reading Template
        case DOWNLOAD_METER_READING_TEMPLATE:
            return {
                ...state,
                downloadLoading: true,
                downloadError: null
            };
        case DOWNLOAD_METER_READING_TEMPLATE_SUCCESS:
            return {
                ...state,
                downloadLoading: false,
                downloadError: null
            };
        case DOWNLOAD_METER_READING_TEMPLATE_FAILURE:
            return {
                ...state,
                downloadLoading: false,
                downloadError: action.data
            };

        // Update Meter Reading
        case UPDATE_METER_READING:
            return {
                ...state,
                updateLoading: true,
                updateError: null,
                updateSuccess: false
            };
        case UPDATE_METER_READING_SUCCESS:
            return {
                ...state,
                updateLoading: false,
                updateSuccess: true,
                updateError: null
            };
        case UPDATE_METER_READING_FAILURE:
            return {
                ...state,
                updateLoading: false,
                updateError: action.data,
                updateSuccess: false
            };

        // Delete Meter Reading
        case DELETE_METER_READING:
            return {
                ...state,
                deleteLoading: true,
                deleteError: null,
                deleteSuccess: false
            };
        case DELETE_METER_READING_SUCCESS:
            return {
                ...state,
                deleteLoading: false,
                deleteSuccess: true,
                deleteError: null
            };
        case DELETE_METER_READING_FAILURE:
            return {
                ...state,
                deleteLoading: false,
                deleteError: action.data,
                deleteSuccess: false
            };

        // Clear State
        case CLEAR_METER_READING_STATE:
            return initialState;

        default:
            return state;
    }
};

export default MeterReadingReducer;
